import { FpsDao } from "../dao";
import {
  FineSearchReq,
  FineSearchRes,
  FineValueReq,
  FineValueRes,
  Fps,
  FpsMedia,
  FpsId
} from "../model";

export class FpsService {
  private readonly _fpsDao: FpsDao;

  public constructor(fpsDao: FpsDao) {
    this._fpsDao = fpsDao;
  }

  public async calcFps(
    cityId: string,
    fineValueReq: FineValueReq
  ): Promise<FineValueRes> {
    try {
      return await this._fpsDao.calcFps(cityId, fineValueReq);
    } catch (error) {
      throw error;
    }
  }

  public async saveFps(cityId: string, fps: Fps): Promise<Fps> {
    try {
      return await this._fpsDao.saveFps(cityId, fps);
    } catch (error) {
      throw error;
    }
  }

  public async searchFps(
    cityId: string,
    fineSearchReq: FineSearchReq
  ): Promise<FineSearchRes> {
    try {
      return await this._fpsDao.searchFps(cityId, fineSearchReq);
    } catch (error) {
      throw error;
    }
  }

  public async saveFpsMedia(cityId: string, fpsMedia: FpsMedia): Promise<void> {
    try {
      return await this._fpsDao.saveFpsMedia(cityId, fpsMedia);
    } catch (error) {
      throw error;
    }
  }

  public async getLastId(
    cityId: string,
    organisationid: string,
    matricule?: string,
    date?: string,
    options?: any
  ): Promise<FpsId> {
    try {
      return await this._fpsDao.getLastId(
        cityId,
        organisationid,
        matricule,
        date,
        options
      );
    } catch (error) {
      throw error;
    }
  }

  public async getNextId(
    cityId: string,
    organisationid: string,
    matricule?: string,
    date?: string,
    options?: any
  ): Promise<FpsId> {
    try {
      return await this._fpsDao.getNextId(
        cityId,
        organisationid,
        matricule,
        date,
        options
      );
    } catch (error) {
      throw error;
    }
  }
}

export default FpsService;
